import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import PageTabHeader from "@/App/Layouts/PageBody/PageTabHeader";
import ViewContentBlock from "@/App/Layouts/ViewContentBlock";
import { ViewLayout } from "@/App/Layouts/ViewLayout";
import AssetSubscriptionPlanAvailabilityDisplay from "@/common/components/Entity/AssetSubscriptionPlan/AssetSubscriptionPlanAvailabilityDisplay";
import { ViewVariant } from "@/common/ts/layout";
import { AssetSubscriptionPlanDto } from "@/core/api/generated/v1";

interface Props {
  assetSubscriptionPlan: AssetSubscriptionPlanDto;
}

export default function AvailabilityTabContent({ assetSubscriptionPlan }: Props) {
  return (
    <PageTabContent>
      <ViewLayout
        displayProps={{ viewVariant: ViewVariant.Tab }}
        header={<PageTabHeader title={"Availability"} />}
      >
        <ViewContentBlock>
          <AssetSubscriptionPlanAvailabilityDisplay
            plan={assetSubscriptionPlan}
            availability={undefined}
            isLoad
          />
        </ViewContentBlock>
      </ViewLayout>
    </PageTabContent>
  );
}
